class LocalStorageServices {
  static keys = { token: 'token', profile: 'profile' };

  static getToken = () => {
    const isTokenInSessionStorage = localStorage.getItem('isTokenInSessionStorage') === 'true';

    const token = (isTokenInSessionStorage ? sessionStorage.getItem('token') : localStorage.getItem('token')) || '';
    return token;
  };

  static setToken = (token, shouldSaveInSessionStorage = false) => {
    if (shouldSaveInSessionStorage) {
      sessionStorage.setItem('token', token);
      localStorage.setItem('isTokenInSessionStorage', 'true');
    } else localStorage.setItem('token', token);
  };

  static removeToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('isTokenInSessionStorage');
    sessionStorage.removeItem('token');
  };

  static getLanguage = () => localStorage.getItem('lang') || 'ru';

  static setLang = (lang) => {
    localStorage.setItem('lang', lang);
  };
}

export default LocalStorageServices;
